import { Link } from "react-router-dom";
import { Button } from "@/components/Base/Button";
import { Icon } from "@/components/Common/Icon";
import { IconNames } from "@/types/v2";
import { ICON_ONLY_HEADER_LINKS } from "@/lib/const";

export const MetricsHeader = ({ shopId }: { shopId: string }) => {
  return (
    <Link to={`/${shopId}`}>
      <Button
        className="h-9 rounded-md p-2 text-sm font-semibold hover:bg-slate-200 hover:opacity-100"
        variant="ghost-primary"
      >
        <Icon name={IconNames.dashboard} className="mr-2.5" size={20} />
        {!ICON_ONLY_HEADER_LINKS && "Dashboard"}
      </Button>
    </Link>
  );
};
